export default "__VITE_ASSET__cb956fbc__"